import * as chrono from 'chrono-node'
import * as React from 'react'
import TextInput from './TextInput'

interface DateInputProps {
  name: string
  label?: React.ReactNode
  labelClassName?: string
  className?: string
  style?: string
  chronoInstance?: chrono.Chrono
  placeholder?: string
}

const DateInput = ({
  name,
  label,
  labelClassName,
  className,
  style,
  chronoInstance = chrono.en.GB,
  placeholder = 'e.g. 25/06/1982',
}: DateInputProps) => (
  <TextInput
    className={`${className} small-text-input`}
    style={style}
    name={name}
    labelClassName={labelClassName}
    label={
      label || (
        <>
          <span>Date of Birth </span>
          <span className="has-text-weight-light has-text-info">(e.g. 25/06/1982)</span>
        </>
      )
    }
    placeholder={placeholder}
    type="text"
    helpFn={(value) => (
      <p className="help is-success">
        {chronoInstance.parseDate(value)?.toLocaleDateString(undefined, {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>
    )}
  />
)

export default DateInput
